<script setup lang="ts">
defineOptions({
  name: 'DHelpTooltip',
})

defineProps<{
  help: string
}>()
</script>

<template>
  <DTooltip
    is="span"
    :title="help"
    class="cursor-help underline decoration-dashed decoration-grey-100"
  >
    <slot />
  </DTooltip>
</template>
